module.exports = __webpack_public_path__ + "img/i-plus.6364f055.svg";